require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/.deno/core-js@2.6.12/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 229
// module chunks = 0